import { Controller } from "@hotwired/stimulus"
import { Sortable, MultiDrag } from "sortablejs"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static values = {
    url: String,
    // animation: Number,
    // handle: String,
    multiDrag: Boolean,
    selectedClass: String,
  }

  initialize() {
    if (this.multiDragValue) {
      Sortable.mount(new MultiDrag())
    }
    this.onUpdate = this.onUpdate.bind(this)
  }

  connect() {
    this.sortable = new Sortable(this.element, {
      ...this.defaultOptions,
      ...this.options,
    })
  }

  disconnect() {
    this.sortable.destroy()
    this.sortable = undefined
  }

  async onUpdate({ item, newIndex }) {
    if (!this.urlValue) return

    const data = this.serialize(this.element)

    await patch(this.urlValue + "?" + data, {
      contentType: "text/javascript",
    })
  }

  // Borrowed from JQuery UI Sortable
  serialize(o) {
    var items = o.children,
      str = []
    o = o || {}

    $(items).each(function () {
      var res = ($(o.item || this).attr(o.attribute || "id") || "").match(
        o.expression || /(.+)[\-=_](.+)/
      )
      if (res) {
        str.push(
          (o.key || res[1] + "[]") +
            "=" +
            (o.key && o.expression ? res[1] : res[2])
        )
      }
    })

    if (!str.length && o.key) {
      str.push(o.key + "=")
    }

    return str.join("&")
  }

  get options() {
    return {
      multiDrag: this.multiDragValue || this.defaultOptions.multiDrag || false,
      selectedClass:
        this.selectedClassValue ||
        this.defaultOptions.selectedClass ||
        "sortable-selected",
      // animation: this.animationValue || this.defaultOptions.animation || 150,
      // handle: this.handleValue || this.defaultOptions.handle || undefined,
      onUpdate: this.onUpdate,
    }
  }

  get defaultOptions() {
    return {}
  }
}
